import { render, staticRenderFns } from "./header-mobile.vue?vue&type=template&id=def3488c&scoped=true&"
import script from "./header-mobile.vue?vue&type=script&lang=js&"
export * from "./header-mobile.vue?vue&type=script&lang=js&"
import style0 from "./header-mobile.vue?vue&type=style&index=0&id=def3488c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "def3488c",
  null
  
)

export default component.exports